import { render, staticRenderFns } from "./ppcVip.vue?vue&type=template&id=7a87c3bf"
import script from "./ppcVip.vue?vue&type=script&lang=js"
export * from "./ppcVip.vue?vue&type=script&lang=js"
import style0 from "./ppcVip.vue?vue&type=style&index=0&id=7a87c3bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports